export const SET_CELLGROUPS = 'SET_CELLGROUPS';
export const SET_CELLGROUP = 'SET_CELLGROUP';
export const ADD_CELLGROUP = 'ADD_CELLGROUP';
export const UPDATE_CELLGROUP = 'UPDATE_CELLGROUP';
export const REMOVE_CELLGROUP = 'REMOVE_CELLGROUP';
export const CLEAR_CELLGROUP = 'CLEAR_CELLGROUP';
export const CLEAR_CELLGROUPS = 'CLEAR_CELLGROUPS';
